import * as React from 'react';
import { flatMap, isString } from 'lodash';
import styled from 'styled-components';

import { IFilterResult, GroupFilterSettings, getFilterOptionDisplay } from '../../filterLib';
import { Button } from '../../../controls/button';

import './index.css';
import { NewFilterStatus } from './newFilterStatus';

export const RemoveFilterButton = styled(Button)`
  margin-left: auto;
  margin-right: 1rem;
  width: 0;
  border: none;
  padding: 0;
  &:hover {
    color: #000;
  }
  &:active {
    outline: none;
  }
`;

RemoveFilterButton.displayName = 'RemoveFilterButton';

export interface IFilterStatus {
  id: string,
  display: string,
  group?: string
}

export interface IProps {
  selectedFilters: IFilterStatus[],
  filterClasses?: GroupFilterSettings,
  onFilterRemoved?: (id: string, item: IFilterStatus) => void,
  onNavigateFilters?: (id: string, item: IFilterStatus) => void,
  onEditFilters?: () => void,
  onClearFilters?: () => void
}

export const FilterStatus = (props: IProps) => {
  return <NewFilterStatus {...props} />;
};

export function convertFilterToStatus(filter: IFilterResult): IFilterStatus[] {
  return flatMap(filter, (filterGroup, key) => {
    if (typeof filterGroup === 'boolean') return [];
    return filterGroup.map((f) => {
      if (isString(f)) {
        return { id: f, display: f, group: key };
      }
      const display = f.statusValue || getFilterOptionDisplay(f);
      return { id: f.id, display, group: key };
    });
  });
}
